<div class="modal-container justify-between md:justify-normal">
    <div class="modal-close-container">
      <bizz-icon
        class="ml-auto block h-5 w-5 text-button md:ml-0"
        (click)="dialogRef.close()"
        iconName="xmark"
        [hover]="true">
      </bizz-icon>
    </div>
    <div class="modal-body">
      <div class="modal-header">
        <h1>
          {{ 'FileChangesFor' | translate }}&nbsp;"{{dataItem.Title}}"
        </h1>
        <p>{{ 'Info_HistoryOfaFile' | translate }}</p>
      </div>
      <hr class="my-4" />
      @if (model.length > 0) {
          <div class="flex max-h-[80%] w-full flex-col overflow-y-auto">
              @for (item of model; track item.ID;) {
                <div class="mb-4 flex flex-row items-center text-xs">
                    <!-- Extension icon -->
                    <bizz-extension-icon [extension]="item.Extension" [size]="'large'" class="mr-3"/>
                    <div class="flex flex-1 flex-row items-center">
                        <div class="flex flex-col">
                            <div class="flex flex-col md:flex-row">
                                <div>{{'UploadedBy' | translate}}&nbsp;<span class="font-bold">{{item.UploadedBy}}</span></div>
                                <span class="hidden md:flex">&nbsp;</span>
                                <div>{{'at' | translate}}&nbsp;<span class="font-bold">{{ item.Date | utcDateTime }}</span></div>
                            </div>
                            <div class="flex flex-row text-lighter md:text-widget">
                                <!-- Extension-->
                                <div class="hidden md:mr-4 md:flex">{{item.Extension}}</div>
                                <!-- Size -->
                                <div>{{item.Size | bytes}}</div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <bizz-icon 
                            class="inline-block h-6 w-6 text-widget-button hover:cursor-pointer hover:text-blue-600 focus:text-blue-600" 
                            iconName="download"
                            (click)="download(item)">
                        ></bizz-icon>
                    </div>                  
                </div>
              }      
          </div>
      }
    </div>  
</div>